import React, { CSSProperties } from 'react';
import AgTypography from '../../Styles/AgTypography';
import { AgColor } from '../../Styles/AgColor';
import { Box, Popover } from '@mui/material';

export interface AgRoleChipsProps {
  type?: 'member' | 'staff' | 'organization';
  message?: string;
  style?: CSSProperties;
  popOverTitle?: string;
  popOverDescription?: string;
}

const mainColors = {
  member: AgColor.turquoiseMain,
  staff: AgColor.purpleMain,
  organization: AgColor.blueMain,
  default: AgColor.secondaryDark
};

const lightColors = {
  member: AgColor.turquoiseLight,
  staff: AgColor.purpleLight,
  organization: AgColor.blueLight,
  default: AgColor.secondaryLight,
};

const AgRoleChip = (
  {
    type,
    message,
    style,
    popOverTitle,
    popOverDescription
  }: AgRoleChipsProps
) => {
  const hasPopover = (popOverTitle && popOverTitle?.length > 0) || (popOverDescription && popOverDescription?.length > 0);

  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);

  const handlePopOverClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopOverClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'ag-role-chip-popover' : undefined;

  return (
    <>
      <AgTypography
        contentStyle={'AP.H4.Medium'}
        style={{
          padding: '8px 12px',
          borderRadius: '16px',
          height: '32px',
          boxSizing: 'border-box',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: 'fit-content',
          backgroundColor: lightColors[type || 'default'],
          color: mainColors[type || 'default'],
          cursor: 'pointer',
          ...style
        }}
        onClick={handlePopOverClick}
      >
        {message}
      </AgTypography>
      {
        hasPopover &&
        <Popover
          id={id}
          open={open}
          anchorEl={anchorEl}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          sx={{ mt: 1 }}
          onClose={handlePopOverClose}
        >
          <Box p={2} width={328}>
            { popOverTitle &&
              <AgTypography contentStyle='AP.H3.Bold' sx={{ pb: 1, borderBottom: '1px solid' + AgColor.grey4 }}>{popOverTitle}</AgTypography>
            }
            { popOverDescription &&
              <AgTypography contentStyle='AP.Paragraph.Medium.Regular' sx={{ pt: 1 }}>{popOverDescription}</AgTypography>
            }
          </Box>
        </Popover>
      }
    </>
  );
};

export default AgRoleChip;